import { render, staticRenderFns } from "./Step02Category.vue?vue&type=template&id=cb537036"
import script from "./Step02Category.vue?vue&type=script&lang=js"
export * from "./Step02Category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports